import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";
import { storeConfig } from "../../config/store.config";

// Official 9'One Store logo. The source image has a black background which
// blends seamlessly into the dark header/footer. Swap /public/logo.jpg to
// update the brand mark everywhere.
const Logo = ({ className, imgClassName, onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    aria-label={`${storeConfig.storeName} — home`}
    data-testid="brand-logo"
    className={cn("inline-flex items-center", className)}
  >
    <img
      src="/logo.jpg"
      alt={`${storeConfig.storeName} logo`}
      className={cn("h-11 w-auto select-none", imgClassName)}
      width="120"
      height="44"
    />
  </Link>
);

export default Logo;
